<template>
    <div v-if="questionReady && rawAnswers" class="max-w-lg mx-auto md:mt-5">
        <div class="max-w-sm mx-auto height-answer">
            <p class="theme-question-text-color theme-question-shadow text-center text-white font-size-16 mb-4">
                <i class="theme-question-shadow fas fa-arrows-alt"></i>
                {{
                    typeof question.custom_message !== 'undefined' && question.custom_message.length > 0
                        ? question.custom_message
                        : $t('sorting_dragdrop_order_answer')
                }}
            </p>
            <draggable
                v-model="rawAnswers"
                handle=".dnd-move"
                :move="
                    () => {
                        sound.play('pop')
                    }
                "
            >
                <div
                    :key="index"
                    v-for="(answer, index) in rawAnswers"
                    :class="{
                        'mb-2 flex items-center answer dnd-move': true,
                        'with-img': haveImage,
                        'only-img': !answer.title && answer.image
                    }"
                >
                    <div v-if="!answer.title && answer.image" class="relative">
                        <i
                            class="fas fa-arrows-alt-v drag-arrow font-size-20 md:font-size-22 absolute shadow-text-none"
                        ></i>
                        <div
                            :style="`background-image: url(${answer.image}); ${!answer.title ? 'margin-right: 0' : ''}`"
                            class="img"
                        ></div>
                    </div>
                    <div
                        v-if="haveImage && answer.image && answer.title"
                        :style="{ 'background-image': 'url(' + answer.image + ')' }"
                        class="img"
                    ></div>

                    <div v-if="haveImage && !answer.image" class="non-img"></div>
                    <div
                        v-if="answer.title"
                        class="theme-button btn md:btn-large btn-block font-bold font-size-20 md:font-size-22 font-opensans btn-answer flex items-center"
                    >
                        <i class="fas fa-arrows-alt-v shadow-text-none"></i>
                        <span class="flex-1 shadow-text-none">{{ answer.title }}</span>
                    </div>
                </div>
            </draggable>
        </div>
        <div class="flex items-center flex-col justify-center w-full h-full pt-6 md:pt-5">
            <button
                class="theme-button btn text-2xl font-opensans font-size-22 block mb-1 uppercase submit-btn"
                @click="answerSubmit"
            >
                {{ $t('sorting_button_submit') }}
            </button>
        </div>
    </div>
</template>

<script>
import draggable from 'vuedraggable'
import Sound from '@/lib/sound.js'

import pop from '@/assets/sounds/pop.mp3'
import definite from '@/assets/sounds/definite.mp3'

export default {
    props: {
        question: {
            type: Object,
            default: null
        }
    },

    components: {
        draggable
    },

    created() {
        this.sound.registerSound({ id: 'pop', src: pop })
        this.sound.registerSound({ id: 'definite', src: definite })
    },

    mounted() {
        if (
            this.question.answers.filter(item => typeof item.initIndex !== 'undefined' && item.initIndex != null)
                .length > 0
        ) {
            this.$nextTick(() => {
                this.getSortCorrectValue()
                this.checkHaveImage()

                setTimeout(() => {
                    window.dispatchEvent(new CustomEvent('componentAlready'))
                }, 200)
            })
        }
    },

    data() {
        return {
            questionReady: false,
            rawAnswers: null,
            haveImage: false,
            sound: new Sound()
        }
    },

    methods: {
        getSortCorrectValue() {
            this.rawAnswers = this.shuffle(this.question.answers)

            if (this.checkSortValue(this.rawAnswers) > 50) {
                this.getSortCorrectValue()
            } else {
                this.questionReady = true
            }
        },

        checkHaveImage() {
            this.haveImage =
                this.rawAnswers.filter(item => item.image != null && item.image != '' && item.title).length > 0
        },

        shuffle(array) {
            var j, x, i
            for (i = array.length - 1; i > 0; i--) {
                j = Math.floor(Math.random() * (i + 1))
                x = array[i]
                array[i] = array[j]
                array[j] = x
            }
            return array
        },

        checkSortValue(array1 = []) {
            var matchTime = 0

            if (array1.length > 0) {
                array1.forEach((item, index) => {
                    if (array1[index].initIndex == index) {
                        matchTime++
                    }
                })
            }

            return (matchTime / parseInt(array1.length)) * 100
        },

        answerSubmit() {
            let sortingList = this.rawAnswers.map(item =>
                    ['initIndex'].reduce((inArray, key) => {
                        inArray = item[key]
                        return inArray
                    }, {})
                ),
                accepted_percentage =
                    this.question.answers[0].data.completely_correct ||
                    this.question.answers[0].data.completely_correct == undefined
                        ? 100
                        : parseFloat(this.question.answers[0].data.accepted_percentage)

            const result = {
                value: this.checkSortValue(this.rawAnswers) >= accepted_percentage,
                sortingList: sortingList
            }

            // this.sound.play('definite') // try to use sound 'pop' instead of 'definite'
            if (this.isPlayAlone) {
                this.sound.play('pop')
            }
            this.$emit('value', result)
        }
    }
}
</script>

<style lang="scss" scoped>
.with-img {
    .img {
        display: flex;
        width: 100%;
        background-size: cover;
        height: 3em;
        width: 3em;
        border-radius: 50%;
        margin-right: 1em;
    }

    .btn-block {
        width: calc(100% - 3em);
    }
}

.only-img {
    justify-content: center;

    .img {
        display: flex;
        background-size: cover;
        height: 6em;
        width: 6em;
        border-radius: 0.5em;
        border: 3px solid black;
    }
}

.btn-block {
    width: 100%;
    word-break: break-word;
}

.non-img {
    margin-right: 4em;
}

.height-answer {
    // overflow-y: auto;
    // height: 35vh;
}

.submit-btn {
    padding: 0.4rem 2rem;
}

.drag-arrow {
    top: 50%;
    left: -1.4rem;
    transform: translateY(-50%);
    color: var(--button-text-color);
}

.btn {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
}
</style>
